<template>
  <div class="home">
    <topNav></topNav>
    <div class="ind_video"><video :src="videoUrl" id="myVideo" controls
        disablepictureinpicture="" autoplay="true" loop="" muted ref="videoPlayer" @mouseenter="playVideo"
        @click="clickplayVideo"></video></div>
    <div class="ind_ban pc">
      <img src="@/assets/img/homeban1.png" />
      <img src="@/assets/img/homeban2.png" />
      <img src="@/assets/img/homeban3.png" />
    </div>
    <div class="ind_ban mob">
      <img src="@/assets/img/homeban_mb1.png" />
      <img src="@/assets/img/homeban_mb2.png" />
      <img src="@/assets/img/homeban_mb3.png" />
    </div>
    <bottomNav></bottomNav>
    <!-- <div class="aiImg" @click="goRouter('/ai')"><img src="@/assets/img/ai.png" alt="" ></div> -->
    <ai v-if="false" />

  </div>
</template>

<script>
// @ is an alias to /src
import { config } from '@/api/user'
import bottomNav from '@/components/bottomNav.vue'
import topNav from '@/components/topNav.vue'
import ai from '@/components/ai.vue'
export default {
  name: 'HomeView',
  components: {
    topNav,
    bottomNav,
    ai,
  },
  data() {
    return {
      videoUrl:''
    }
  },
  mounted() {
	  
    this.getInfo();
    window.addEventListener('scroll', this.updateScrollTop);
  },
  methods: {
    async getInfo(){
      let res = await config({});
      console.log('res12',res);
      this.videoUrl = res.data.site_home_video;
    },
    playVideo() {
      const video = this.$refs.videoPlayer;
      var that = this;
      if (video.paused) {
        video.play().catch(error => {
          // console.error('1111Auto play failed:', error);
        });
      }
    },
    updateScrollTop() {
      // this.playVideo();
    },
    clickplayVideo() {
      const myVideo = document.getElementById('myVideo');
      myVideo.play();
    }


  }
}
</script>
